import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App";
import AppWrapper from "./components/App/AppWrapper";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
    <AppWrapper>
        <App />
    </AppWrapper>,
    document.getElementById("root") as HTMLElement,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
